const ContactInfo = () => {
  return (
    <div className="lg:col-span-2 bg-[#8B9D7C] p-12 lg:p-16 flex flex-col justify-center relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <pattern id="leaf-pattern-contact" x="0" y="0" width="60" height="60" patternUnits="userSpaceOnUse">
            <path d="M30 5 Q40 20 30 35 Q20 20 30 5" fill="currentColor" className="text-white" />
          </pattern>
          <rect width="100%" height="100%" fill="url(#leaf-pattern-contact)" />
        </svg>
      </div>

      <div className="relative z-10">
        <h2 className="text-4xl md:text-5xl font-serif text-white mb-6 leading-tight">
          Parliamone<br />Insieme
        </h2>
        <p className="text-white/85 text-lg mb-12 leading-relaxed">
          Siamo qui per aiutarti. Contattaci per qualsiasi domanda sui nostri prodotti 
          o per ricevere assistenza.
        </p>

        <div className="space-y-6 mb-12">
          <div className="flex items-start">
            <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-full mr-4 flex-shrink-0">
              <i className="ri-phone-line text-white text-xl"></i>
            </div>
            <div>
              <p className="text-white/70 text-sm mb-1">Telefono</p>
              <a href="tel:+390212345678" className="text-white text-lg font-medium hover:underline cursor-pointer">
                0230310856
              </a>
            </div>
          </div>

          <div className="flex items-start">
            <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-full mr-4 flex-shrink-0">
              <i className="ri-mail-line text-white text-xl"></i>
            </div>
            <div>
              <p className="text-white/70 text-sm mb-1">Email</p>
              <a href="mailto:info@agro-innovazioni.it" className="text-white text-lg font-medium hover:underline cursor-pointer">
                info@agro-innovazioni.it
              </a>
            </div>
          </div>

          <div className="flex items-start">
            <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-full mr-4 flex-shrink-0">
              <i className="ri-time-line text-white text-xl"></i>
            </div>
            <div>
              <p className="text-white/70 text-sm mb-1">Orari di Apertura</p>
              <p className="text-white text-lg font-medium">Lun - Ven: 9:00 - 18:00</p>
              <p className="text-white text-sm">Sabato: 9:00 - 13:00</p>
            </div>
          </div>
        </div>

        <div>
          <p className="text-white/70 text-sm mb-4">Seguici sui Social</p>
          <div className="flex items-center space-x-3">
            <a
              href="#"
              className="w-12 h-12 flex items-center justify-center border border-white/30 rounded-lg hover:bg-white/10 transition-colors cursor-pointer"
            >
              <i className="ri-instagram-line text-white text-xl"></i>
            </a>
            <a
              href="#"
              className="w-12 h-12 flex items-center justify-center border border-white/30 rounded-lg hover:bg-white/10 transition-colors cursor-pointer"
            >
              <i className="ri-facebook-fill text-white text-xl"></i>
            </a>
            <a
              href="#"
              className="w-12 h-12 flex items-center justify-center border border-white/30 rounded-lg hover:bg-white/10 transition-colors cursor-pointer"
            >
              <i className="ri-linkedin-fill text-white text-xl"></i>
            </a>
            <a
              href="#"
              className="w-12 h-12 flex items-center justify-center border border-white/30 rounded-lg hover:bg-white/10 transition-colors cursor-pointer"
            >
              <i className="ri-twitter-x-line text-white text-xl"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;